<template>
  <div class="tipcontent">
    <!-- <van-image :src="classDetial.coverPictureUrl" /> -->
    <div class="tipinfo"  v-if="showTips">
      <span class="title"><b></b>声明：</span>
      <span class="info"><div>本公司无第三方代收款账户，请认准小筑教育官方收款码！核实电话：010-57130711</div></span>
      <span class="close" @click="deleteinfo()"></span>
    </div>
    <img :src="classDetial.coverPictureUrl" />
    <Title :classDetial="classDetial" />
    <ClassTabs :classDetial="classDetial" style="padding-bottom:70px" />
    <Footer class="Footer" :classDetial="classDetial" />
    <Gohome />
  </div>
</template>

<script>
import Title from "@/components/class/title";
import ClassTabs from "@/components/class/classTabs";
import Footer from "@/components/class/footer";
export default {
  components: {
    Title,
    Footer,
    ClassTabs,
  },
  data() {
    return {
      showTips:this.getininfo(),
      classDetial: {
        cname: "",
        vurl:"",
      },
    };
  },
  created() {
    this.getclassDetials();
  },
  methods: {
    deleteinfo(){
      document.cookie = 'xzjytipinfo=1';
      this.showTips=this.getininfo()
    },
    getininfo(){
      if(this.getCookie('xzjytipinfo')==1){
        return false;
      }else{
        return true;
      }
      
    },
    getCookie(name) {
      var reg = RegExp(name + '=([^;]+)');
      var arr = document.cookie.match(reg);
      if (arr) {
          return arr[1];
      } else {
          return '';
      }
    },
    getclassDetials() {
      let data = {
        cid: this.$route.query.cid,
      };
      this.Api({
        url: "api/course/getCourseDetails",
        method: "POST",
        data,
      }).then((res) => {
        this.classDetial = res.data;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.Footer {
  position: fixed;
  bottom: -3px;
  width: 100%;
}

.tipcontent {
  position: relative;
  .tipinfo {
    width: 100%;
    height: 32/20rem;
    top: 0px;
    top: -5px;
    left: 0px;
    z-index: 999;
    position: absolute;
    background: linear-gradient(270deg, #fff5ea 0%, #feeed5 100%);
    display: flex;
    align-items: center;
    .title {
      font-size: 12/20rem;
      background: #fffaf2;
      line-height: 18/20rem;
      padding: 0 0 0 10/20rem;
      color: #f08041;
      height: 18/20rem;
      border-radius: 9/20rem;
      margin-left: 15/20rem;
      b {
        background: url(../../assets/imgs/tip2x.png) center center no-repeat;
        display: inline-block;
        width: 13/20rem;
        height: 12/20rem;
        background-size: contain;
        vertical-align: middle;
        position: relative;
        top: -1px;
      }
    }
    .info {
      flex: 1;
      white-space: nowrap;
      overflow: hidden;
      div {
        font-size:10/20rem;
        color:#333;
        width: 100%;
        animation: 15s scrolltext linear infinite;
      }
    }

    @keyframes scrolltext {
      0% {
        transform: translateX(130%);
      }

      100% {
        transform: translateX(-130%);
      }
    }
    .close {
      background: url(../../assets/imgs/delete2x.png) center center no-repeat;
      width: 10/20rem;
      height: 10/20rem;
      margin: 0 15/20rem;
    }
  }
}
</style>
